import React from 'react';
import { FieldErrors } from 'src/components/createRisk/hooks';
import { ValidationErrors } from 'src/components';

const FORM_VALIDATION_ERRORS_CONFIG = [
  {
    id: 'riskname-input-toggle-button',
    labelText: 'Risk Name',
    formFieldErrorKey: 'title',
  },
  {
    id: 'riskdetails-input',
    labelText: 'Risk Details',
    formFieldErrorKey: 'details',
  },
  {
    id: 'policy-select-toggle-button',
    labelText: 'Internal Policy',
    formFieldErrorKey: 'policyId',
  },
];

interface ValidationErrorsProps {
  fieldErrors: FieldErrors;
}

const CreateRiskValidationErrors = ({ fieldErrors }: ValidationErrorsProps) => {
  return (
    <ValidationErrors
      errorConfigs={FORM_VALIDATION_ERRORS_CONFIG.map((config) => ({
        ...config,
        isError: fieldErrors[config.formFieldErrorKey as keyof FieldErrors],
      }))}
    />
  );
};

export default CreateRiskValidationErrors;
